module.exports = __webpack_public_path__ + "media/images/business/illust-case-03-acbf8b4099e9e285e0e410aa7afd0603.svg";